<div *transloco="let t; read: 'language-selector'"
  class="language-selector-container">
  <label for="language-selector">{{ t('label_select') }}</label>

  <select id="language-selector"
    data-cy="language-selector"
    [attr.aria-label]="t('selected', { language: t('languages.' + selectedLanguage.code) })"
    [value]="selectedLanguage.code"
    (change)="changeLanguage($event)"
    (keydown)="keyboardFocused = true"
    (mouseenter)="keyboardFocused = false">
    @for (language of languages(); track language.code) {
      <option [value]="language.code"
        [attr.lang]="language.code !== selectedLanguage.code ? (language.code | a11yLangAttribute) : null"
        [selected]="language.code === selectedLanguage.code"
        [class.keyboard-focused]="keyboardFocused">
        {{ language.name }}
      </option>
    }
  </select>
</div>
